import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { business } from '../data/business';

const { FiCalendar, FiShield, FiMapPin, FiUser } = FiIcons;

const Stats = () => {
  const facts = [
    { icon: FiCalendar, label: 'Established', value: 'December 2024' },
    { icon: FiShield, label: 'GST Registered', value: business.gstin },
    { icon: FiMapPin, label: 'Based In', value: `${business.address.city}, ${business.address.state}` },
    { icon: FiUser, label: 'Business Type', value: business.constitution }
  ];

  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            A Registered, Trustworthy Business
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Thread & Textile India is a legally registered clothing, apparel, and textile
            trading business you can order from with confidence.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {facts.map((fact, index) => (
            <motion.div
              key={fact.label}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20"
            >
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={fact.icon} className="w-6 h-6 text-white" />
              </div>
              <div className="text-lg md:text-xl font-bold text-white mb-1 break-words">
                {fact.value}
              </div>
              <div className="text-blue-100 text-sm font-medium">{fact.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
